import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sms-services',
  templateUrl: './sms-services.component.html',
  styleUrls: ['./sms-services.component.css']
})
export class SmsServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
